export const TEMPLATE_PLACEHOLDER_SYMBOL = "###";
export const TEMPLATE_PLACEHOLDER_TEXT = "Type Text Here";
export const TEMPLATE_PLACEHOLDER = `${TEMPLATE_PLACEHOLDER_SYMBOL}${TEMPLATE_PLACEHOLDER_TEXT}${TEMPLATE_PLACEHOLDER_SYMBOL}`;
